import type { RrPreviewJornada } from "../lib/api";
import { previewMatchLine, previewMatchPlayers } from "../lib/rrSheetOrder";

/** Cómo quedarían las jornadas tras acomodar la hoja del Round Robin
 * (Eduardo 2026-10-01). Lo comparten «Acomodar grupos» y el diálogo de
 * «Cambiar de grupo»: cada partido con su horario, marcando lo que cambia,
 * lo nuevo (sin horario) y lo que se quita. */
export default function RoundRobinPreviewJornadas({ jornadas }: { jornadas: RrPreviewJornada[] }) {
  if (jornadas.length === 0) {
    return <p className="muted">Sin partidos en este grupo.</p>;
  }
  return (
    <div className="rr-preview-jornadas">
      {jornadas.map((jornada) => (
        <div key={jornada.jornada} className="rr-preview-jornada">
          <strong className="rr-preview-jornada__label">{jornada.label}</strong>
          <ul className="rr-preview-jornada__matches">
            {jornada.matches.map((match, index) => (
              <li
                key={`${match.op}-${match.match_id ?? "nuevo"}-${index}`}
                className={`rr-preview-match rr-preview-match--${match.op}`}
              >
                {match.op === "removed" ? (
                  <s>{previewMatchLine(match)}</s>
                ) : match.op === "new" ? (
                  <span>{previewMatchPlayers(match)}</span>
                ) : (
                  <span>{previewMatchLine(match)}</span>
                )}
                {match.op === "reassigned" ? <em className="rr-preview-match__tag">cambia</em> : null}
                {match.op === "new" ? <em className="rr-preview-match__tag">nuevo, sin horario</em> : null}
                {match.op === "removed" ? <em className="rr-preview-match__tag">se quita</em> : null}
                {match.op !== "removed" && match.op !== "new" && match.unscheduled ? (
                  <em className="rr-preview-match__tag rr-preview-match__tag--unscheduled">queda sin programar</em>
                ) : null}
                {match.op === "reassigned" && match.before ? (
                  <small className="rr-preview-match__before">antes: {previewMatchPlayers(match.before)}</small>
                ) : null}
              </li>
            ))}
          </ul>
          {jornada.resting.length > 0 ? (
            <small className="rr-preview-jornada__rest">
              Descansa: {jornada.resting.map((player) => player.name).join(", ")}
            </small>
          ) : null}
        </div>
      ))}
    </div>
  );
}
